import React from 'react'
import { inject, observer } from 'mobx-react'
import classnames from 'classnames'
import { withTranslation } from 'react-i18next'
import { HugeiconsIcon } from '@hugeicons/react'
import { InformationCircleIcon } from '@hugeicons/core-free-icons'

const PeopleIcon = ({ active = false }) => {
  const stroke = active ? '#FFFFFF' : '#292C44'
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8Z' stroke={stroke} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M16 4C17.6568 4 19 5.34315 19 7C19 8.22309 18.268 9.27523 17.2183 9.7423' stroke={stroke} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M13.7143 14H10.2857C7.91878 14 6 15.9188 6 18.2857C6 19.2325 6.76751 20 7.71428 20H16.2857C17.2325 20 18 19.2325 18 18.2857C18 15.9188 16.0812 14 13.7143 14Z' stroke={stroke} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M17.7148 13C20.0817 13 22.0005 14.9188 22.0005 17.2857C22.0005 18.2325 21.233 19 20.2862 19' stroke={stroke} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M8 4C6.34315 4 5 5.34315 5 7C5 8.22309 5.73193 9.27523 6.78168 9.7423' stroke={stroke} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M3.71429 19C2.76751 19 2 18.2325 2 17.2857C2 14.9188 3.91878 13 6.28571 13' stroke={stroke} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}

const PoiTabIcon = ({ active = false }) => {
  const stroke = active ? '#FFFFFF' : '#292C44'
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12 22C12 22 19 15.5 19 10.5C19 6.35786 15.866 3 12 3C8.13401 3 5 6.35786 5 10.5C5 15.5 12 22 12 22Z' stroke={stroke} strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M12 13.5C13.6569 13.5 15 12.1569 15 10.5C15 8.84315 13.6569 7.5 12 7.5C10.3431 7.5 9 8.84315 9 10.5C9 12.1569 10.3431 13.5 12 13.5Z' stroke={stroke} strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}

const IncomeTabIcon = ({ active = false }) => {
  const stroke = active ? '#FFFFFF' : '#292C44'
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12 3V21' stroke={stroke} strokeWidth='2' strokeLinecap='round' />
      <path d='M16.5 7.5C16.5 5.84315 14.4853 4.5 12 4.5C9.51472 4.5 7.5 5.84315 7.5 7.5C7.5 9.15685 9.51472 10.5 12 10.5C14.4853 10.5 16.5 11.8431 16.5 13.5C16.5 15.1569 14.4853 16.5 12 16.5C9.51472 16.5 7.5 15.1569 7.5 13.5' stroke={stroke} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}

const InfoTabIcon = ({ active = false }) => {
  const stroke = active ? '#FFFFFF' : '#292C44'
  return (
    <HugeiconsIcon
      icon={InformationCircleIcon}
      size={24}
      color={stroke}
      strokeWidth={1.5}
    />
  )
}

const Sections = ({ uiStore, className, handleClick }) => {
  const SECTIONS = [{
    label: 'INFO',
    value: 'info',
    icon: ({ active }) => <InfoTabIcon active={active} />,

  }, {
    label: 'POI',
    value: 'poi',
    icon: ({ active }) => <PoiTabIcon active={active} />,
  }, {
    label: 'PEOPLE',
    value: 'people',
    icon: ({ active }) => <PeopleIcon active={active} />,
  },
  {
    label: 'INCOME',
    value: 'income',
    icon: ({ active }) => <IncomeTabIcon active={active} />,
  }]
  return (
    <div className={className}>
      {SECTIONS.map((section) => (
        <button
          key={section.label}
          className={classnames('poi__button', 'poi__button--tool', { 'poi__button--active': uiStore.activeTab === section.value })}
          type='button'
          onClick={async () => {
            if (uiStore.activeTab === section.value) {
              uiStore.togglePOIMenu()
              return
            }
            uiStore.setActiveTab(section.value)
            uiStore.isPOIMenuExpanded = true
            if (section.value === 'poi') {
              return
            }
            await handleClick()
          }}
        >
          <section.icon active={uiStore.activeTab === section.value} />
          <span className='poi__button-label'>{section.label}</span>
        </button>
      ))}
    </div>
  )
}

export default withTranslation()(
  inject('uiStore')(observer(Sections))
)
